import axios from "axios";
import {API} from "../constants";

axios.defaults.baseURL = API;
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.common['Authorization'] = 'Bearer d1759f8fa56dd40e8d337f9e0878098f22a64a0c';
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.withCredentials = true;

export default axios;